import { accountingFormatNumber } from '@/util/Parsers'

export default ({ building_stock_units, annual_pennetration_rate_final }) => {
  return accountingFormatNumber({ number: (building_stock_units * annual_pennetration_rate_final) / 4, precision: 5 })
}